import { XMark } from '@raydiant/raydial/components/Icons';
import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectShowChatbot } from '../../selectors/common';
import * as commonActions from '../../actions/common';

const AVO_WIDGET_ID = 'avochato-text-us';
const STORAGE_KEY = 'avochato-widget-eVBw7kdBDJ';
const WIDGET_ID = 'eVBw7kdBDJ';

const AvochatoChat = () => {
  const dispatch = useDispatch();
  const showChatbot = useSelector(selectShowChatbot);

  const [isOpen, setIsOpen] = useState(false);
  const [revealerLoaded, setRevealerLoaded] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    if (!showChatbot) return;

    const existing = document.getElementById(AVO_WIDGET_ID);
    if (existing && existing.style.display !== 'none') return;

    const iframe = document.createElement('iframe');
    iframe.id = AVO_WIDGET_ID;
    iframe.src = `https://www.avochato.com/live_chat/${WIDGET_ID}?iframe_domain=${encodeURIComponent(
      window.location.origin,
    )}`;
    iframe.setAttribute(
      'style',
      'position:fixed;bottom:2%;right:2%;border:none;height:100px;width:130px;z-index:100;',
    );

    iframe.onload = () => {
      setTimeout(() => setRevealerLoaded(true), 500);
    };

    document.body.appendChild(iframe);
    iframeRef.current = iframe;

    const handleMessage = (e: MessageEvent) => {
      if (!e.data || typeof e.data !== 'object') return;

      switch (e.data.type) {
        case 'sizeUpdate':
          const newHeight = parseInt(e.data.height || '0', 10);
          setIsOpen(newHeight > 400);
          if (iframeRef.current) {
            if (e.data.height) iframeRef.current.style.height = e.data.height;
            if (e.data.width) iframeRef.current.style.width = e.data.width;
            if (e.data.bottom) iframeRef.current.style.bottom = e.data.bottom;
            if (e.data.right) iframeRef.current.style.right = e.data.right;
          }
          break;

        case 'fetchSession':
          let sessionData = {};
          try {
            sessionData =
              JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
          } catch (_) {}
          const response = {
            ...sessionData,
            type: 'fetchSession',
            accessedAt: Date.now(),
          };
          iframeRef.current?.contentWindow?.postMessage(
            response,
            iframeRef.current.src,
          );
          break;

        case 'saveSession':
          localStorage.setItem(STORAGE_KEY, JSON.stringify(e.data));
          break;

        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [showChatbot]);

  const onCloseChatbot = () => {
    if (iframeRef.current) {
      iframeRef.current.style.display = 'none';
    }
    dispatch(commonActions.toggleChatbot(false));
    setRevealerLoaded(false);
  };

  if (!showChatbot || isOpen || !revealerLoaded) return null;

  return (
    <button
      onClick={onCloseChatbot}
      className="
        fixed
        z-[110]
        bottom-[calc(2%+35px)]
        md:bottom-[calc(2%+45px)]
        right-[calc(2%-8px)]
        md:right-[calc(2%-10px)]
        bg-black
        text-white
        border-none
        text-[16px]
        px-[5px]
        py-[5.5px]
        md:px-[7px]
        md:py-[7.5px]
        rounded-full
        cursor-pointer
      "
    >
      <XMark className="md:ml-[1px]" />
    </button>
  );
};

export default AvochatoChat;
